export const LABELS_TABLE = {
    exportToExcel: 'Експортувати до Excel',
    exportToExcelFull: 'Експортувати всі дані до ексель',
    selectTableToExcel: 'Оберіть таблиці які хочете експортувати',
    selectAllRows: 'Вибрати всі рядки',
    selectAllColumn: 'Вибрати всі колонки',
    allClearColumn: 'Очистити колонки',
    allClearRows: 'Очистити рядки',
}